module.exports = new __parcel__URL__("email.very-specific-illu.3b6402e8.png").toString();